










import { defineComponent, ref } from "@nuxtjs/composition-api";
import LoadWhenVisible from "~/components/utils/LoadWhenVisible.vue";
import { PropType } from "vue";
import { BundleProduct } from "~/composables";
import FullBundleBox from "./FullBundleBox.vue";
import BundleItems from "./BundleItems.vue";
export default defineComponent({
  components: {
    LoadWhenVisible,
    FullBundleBox,
    BundleItems
  },
  props: {
    product: {
      type: Object as PropType<BundleProduct>,
        required: true
    },
  },
  setup(props) {
    const bundleItems = ref<any>( props.product.items[0].options.map(el=>el.product));

    return {
      bundleItems
    }
  },
});
